import { useCMSPageField } from '@/cms/fields'
import { buildImgSrc, buildImgSrcSet } from '@/helpers/image-url'
import { useIntl } from '@/intl'
import { PublicationCodes } from '@/scopes/common/domain/models'
import { useConfiguration } from '@/scopes/common/infrastructure/config/ConfigProvider'
import DestinationSelector from '@/scopes/destinations/components/DestinationSelector/DestinationSelector'
import styles from '@/scopes/destinations/components/Hero/Hero.module.css'
import { Image } from '@sunwebgroup/uds-ui/image'
import React from 'react'
import CommonHero, { MAX_HERO_IMAGE_WIDTH } from '../../Hero'

function Hero() {
  const intl = useIntl()
  const publicationCode = useConfiguration('publicationCode')
  const imageSrc = useCMSPageField('DestinationPage.heroImage')
  const destinationTitle = useCMSPageField('DestinationPage.title')
  const productName = useCMSPageField('DestinationPage.productName')
  const fallbackKey = PublicationCodes.isSunwebWinterPublicationCode(publicationCode)
    ? 'destination_hero_winter_title_fallback'
    : 'destination_hero_summer_title_fallback'
  const title = destinationTitle || intl.formatMessage({ id: fallbackKey }, { productName })

  return (
    <CommonHero
      title={title}
      imageSlot={imageSrc && <HeroImage src={imageSrc} />}
      destinationSelectorSlot={<DestinationSelector />}
    />
  )
}

function HeroImage({ src }: { src: string }) {
  return (
    <Image
      src={buildImgSrc(src, MAX_HERO_IMAGE_WIDTH)}
      className={styles.image}
      alt=""
      srcSet={buildImgSrcSet(src, [480, 960, 1280, MAX_HERO_IMAGE_WIDTH])}
    />
  )
}

export default Hero
